import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BaseDatasource } from '@shared/base/base.datasource';
import { BehaviorSubject, Subscription } from 'rxjs';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

@Component({
  selector: 'app-table-content',
  standalone: true,
  imports: [CommonModule, NgxSkeletonLoaderModule],
  templateUrl: './table-content.component.html',
  styleUrls: ['./table-content.component.scss'],
})
export class TableContentComponent implements OnInit, OnDestroy {
  @Input() count: number = 1;
  @Input() type: string = 'text';
  @Input() height: number = 10;
  @Input() width: number = 180;
  @Input() isFinishLoadingSubject: BehaviorSubject<boolean>;

  private unsubscribe: Subscription[] = [];

  // isFinishLoading: boolean = false
  baseDatasource: BaseDatasource<any>;

  constructor(private ref: ChangeDetectorRef) {}

  ngOnInit(): void {
    // this.setLoading()
  }

  // setLoading() {
  //   if (this.isFinishLoadingSubject) {
  //     const _loadingSubs = this.isFinishLoadingSubject.subscribe( value => this.isFinishLoading = value );
  //     this.unsubscribe.push(_loadingSubs);
  //     this.ref.detectChanges();
  //   }
  // }

  ngOnDestroy() {
    this.unsubscribe.forEach((sb) => sb.unsubscribe());
  }
}
